<template>
  <div class="home_container">
    <!-- 头部轮播 -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in sliderList"
          :key="index"
          class="swiper-slide"
        >
          <img :src="'https://www.jidcon.com/fd/' + item.imgPath" alt="" />
          <div>
            <div>{{ item.title }}</div>
            <div>{{ item.titleEn }}</div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination" />
    </div>

    <!-- 济德动态 -->
    <div class="dynamics">
      <img src="@/assets/images/home/car.png" alt="" />
      <div>
        <div>济德动态</div>
        <div>Related dynamics about JiDC</div>
        <div>
          {{ $t("index.profileDetails") }}
        </div>
      </div>
      <div>
        <a href="/News">{{ $t("index.showMore") }} ></a>
      </div>
    </div>

    <!-- 介绍 -->
    <div class="introduction">
      <img src="@/assets/images/home/pull.png" alt="" />
      <div>以客户为中心 · 以奋斗者为本 · 坚持学习与创新</div>
      <div>Customer Centered, Striver Oriented, Learning and Innovation</div>
      <div />
    </div>

    <!-- 解决方案 -->
    <div class="solutions">
      <div>解决方案</div>
      <div>Solutions</div>
      <div id="car">
        <div :class="{ 'solutions-en': $i18n.locale === 'en_US' }">
          <img src="@/assets/images/home/folder.png" alt="" />
          <div>汽车领域</div>
          <div>Automotive sector</div>
          <div>
            {{
              $i18n.locale === "en_US"
                ? "JiDC has design and manufacturing capabilities for robust and safe solutions for wide range of automotive applications. Supported by advanced manufacturing technologies our design expertise is continuously evolving to both signal and power connectivity to original and future application."
                : " 济德精密提供安全、高可靠性连接器解决方案的设计和制造能力，大量应用汽车各模组。以实现信号和电源的互连"
            }}
          </div>
          <div @click="goto('SolutionList')">
            <span>了解更多</span>
            <img src="@/assets/images/home/next.png" alt="" />
          </div>
        </div>
      </div>
      <div id="solutions" class="solutions-list">
        <div
          v-for="(item, index) in solutions"
          :key="index"
          class="solution-item"
        >
          <img :src="item.img" />
          <div>{{ item.enTile }}</div>
          <div>
            <span>{{ item.zhTitle }}</span>
            <img
              src="@/assets/images/home/next.png"
              alt=""
              @click="goto('SolutionList')"
            />
          </div>
          <div class="solution-text">
            {{ $i18n.locale === "en_US" ? "" : item.text }}
          </div>
        </div>
        <!-- 遮挡 -->
        <div class="solution-list-ball" />
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="partners">
      <div>合作伙伴</div>
      <div>Partner</div>
      <div>
        <div v-for="(item, index) in partners" :key="index">
          <img :src="item.img" alt="" />
        </div>
      </div>
    </div>

    <!-- 济德咨询 -->
    <div class="news">
      <div>济德资讯</div>
      <div>News</div>
      <div>
        <div v-for="(item, index) in newsList" :key="index">
          <div>
            <img :src="item.img" alt="" />
          </div>
          <div>
            {{ item.updateTime }}
          </div>
          <div>
            {{ $i18n.locale === "en_US" ? item.enTitle : item.title }}
          </div>
          <div>
            {{
              $i18n.locale === "en_US" ? item.enDescription : item.description
            }}
          </div>
          <div @click="goto('News')">
            {{ $i18n.locale === "en_US" ? "Show More" : "查看更多" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- <script src="https://cdn.bootcdn.net/ajax/libs/Swiper/11.0.5/swiper-bundle.min.js"></script> -->
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  name: `Main`,
  data() {
    return {
      btnImg: require("/src/assets/images/btn.png"),
      dynamicImg1: require("/src/assets/images/dynamic-1.png"),
      dynamicImg2l: require("/src/assets/images/dynamic-2-l.png"),
      dynamicImg2r: require("/src/assets/images/dynamic-2-r.png"),
      rightArrow: require("/src/assets/images/arrow-right.png"),

      solutions: [
        {
          zhTitle: "新能源连接器",
          enTile: "New energy connector",
          titleColor: "#234B76",
          text: "济德精密的广泛连接器组合，高性能技术积累为汽车电气化提供了完整解决方案。",
          enText:
            "The wide range of connector combinations and the accumulation of high-performance technologies of JiDC provide a complete solution for automobile electrification.",
          img: require("/src/assets/images/newEnergy.png"),
        },
        {
          zhTitle: "重载连接器（非道路）",
          enTile: "Connector",
          titleColor: "#3491F7",
          text: "济德精密为恶劣环境应用开发创新解决方案多年。我们在运输行业的专业知识和应用方面有着良好表现，为客户提供最广泛的互连产品组合。",
          enText:
            "JiDC has been developing innovative solutions for harsh environment application for years. We have a proven track record of demonstrating our expertise and commitment to the transportation industry, offering the broadest portfolio of interconnect products.",
          img: require("/src/assets/images/conn.png"),
        },
        {
          zhTitle: "家电",
          enTile: "Electrical applications",
          titleColor: "#3491F7",
          text: "济德精密可提供整套可靠的电气解决方案来支持家电领域的应用。从连接器到线束济德精密可以同时支持传统家电和智能家居应用的需求。",
          enText:
            "JiDC offers a complete line of reliable electrical solutions designed to support appliance application. Our industry-leading solutions from connectors to cable harness supporting the needs of both original home appliance and smart appliance application.",
          img: require("/src/assets/images/elecApp.png"),
        },
        {
          zhTitle: "光伏，绿色能源",
          enTile: "Green energy",
          titleColor: "#234B76",
          text: "济德精密基于高度可靠且经行业验证的复合金属成型技术开发先进的连接器解决方案。我们的解决方案应用于汽车、家电、工业应用和光伏，风能等行业",
          enText:
            "JiDC develops advanced connector solutions based on our highly reliable and industry-proven Multiple Mentals Formed technology. Our solutions are used in industries such as automotive, appliance, industries application and also solar energies.",
          img: require("/src/assets/images/greenEnergy.png"),
        },
      ],
      partners: [
        { img: require("/src/assets/images/home/partner_img1.png") },
        { img: require("/src/assets/images/home/partner_img2.png") },
        { img: require("/src/assets/images/home/partner_img3.png") },
        { img: require("/src/assets/images/home/partner_img4.png") },
        { img: require("/src/assets/images/home/partner_img5.png") },
        { img: require("/src/assets/images/home/partner_img6.png") },
        { img: require("/src/assets/images/home/partner_img7.png") },
        { img: require("/src/assets/images/home/partner_img8.png") },
        { img: require("/src/assets/images/home/partner_img9.png") },
        { img: require("/src/assets/images/home/partner_img10.png") },
        { img: require("/src/assets/images/home/partner_img11.png") },
        { img: require("/src/assets/images/home/partner_img12.png") },
        { img: require("/src/assets/images/home/partner_img13.png") },
        { img: require("/src/assets/images/home/partner_img14.png") },
        { img: require("/src/assets/images/home/partner_img15.png") },
        { img: require("/src/assets/images/home/partner_img16.png") },
        { img: require("/src/assets/images/home/partner_img17.png") },
        { img: require("/src/assets/images/home/partner_img18.png") },
        { img: require("/src/assets/images/home/partner_img19.png") },
        { img: require("/src/assets/images/home/partner_img20.png") },
        { img: require("/src/assets/images/home/partner_img21.png") },
        { img: require("/src/assets/images/home/partner_img22.png") },
        { img: require("/src/assets/images/home/partner_img23.png") },
        { img: require("/src/assets/images/home/partner_img24.png") },
        { img: require("/src/assets/images/home/partner_img25.png") },
        { img: require("/src/assets/images/home/partner_img26.png") },
        { img: require("/src/assets/images/home/partner_img27.png") },
        { img: require("/src/assets/images/home/partner_img28.png") },
        { img: require("/src/assets/images/home/partner_img29.png") },
        { img: require("/src/assets/images/home/partner_img30.png") },
      ],
      // 济德资讯列表
      newsList: [],
      // 轮播图列表
      sliderList: [],
      slider: null,
    };
  },
  created() {
    this.getNewsList();
    this.getSliderList();
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  },
  methods: {
    goto(path) {
      this.$router.push("/" + path);
    },

    async getSliderList() {
      let url = "/admin/carousel/list";
      const { data } = await this.$doGet(url).catch((err) => {});
      this.sliderList = data;
      this.$nextTick(() => {
        this.swiper = new Swiper(".swiper-container", {
          loop: true,

          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          autoplay: {
            delay: 5000,
          },
        });
        // 显式启动自动播放
        if (this.swiper.autoplay) {
          this.swiper.autoplay.start();
        }
      });
    },

    async getNewsList() {
      let url = "/item/information/listInformationByPage";
      let param = {
        size: 3,
        current: 1,
        total: 0,
      };
      const { data } = await this.$doPost(url, param).catch((err) => {
        return { data: null };
      });
      this.newsList = data?.records;
    },
  },
};
</script>
<style lang="less" scoped>
.home_container {
  position: relative;
  overflow: hidden;
  // 头部背景
  ::v-deep .swiper-container {
    width: 100%;
    margin: 0 auto;
    height: 788px;
    overflow: hidden;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
    margin-bottom: 30px;
    position: relative;
  }
  ::v-deep .swiper-wrapper {
    /* 确保 wrapper 有这些样式 */
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
  ::v-deep .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    > div {
      position: absolute;
      > div:nth-child(1) {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 52px;
        color: #ffffff;
        line-height: 72px;
        text-align: center;
      }
      > div:nth-child(2) {
        font-family: Montserrat, Montserrat;
        font-weight: 300;
        font-size: 22px;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
      }
    }
  }

  ::v-deep .swiper-pagination-bullet {
    width: 12px !important;
    height: 12px !important;
    background: rgba(255, 255, 255, 0.7) !important;
    opacity: 1 !important;
  }
  ::v-deep .swiper-pagination-bullet-active {
    background: white !important;
  }

  // 济德动态
  .dynamics {
    width: 1200px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 0px 26px 0px rgba(0, 0, 0, 0.08);
    padding: 23px 33px;
    box-sizing: border-box;
    display: flex;
    position: relative;
    top: -73px;
    z-index: 10;
    backdrop-filter: blur(28.4px);
    > img:nth-child(1) {
      height: 196px;
      width: 196px;
      margin-right: 35px;
    }
    > div:nth-child(2) {
      flex: 1;
      display: flex;
      flex-direction: column;
      > div:nth-child(1) {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 28px;
        color: #222222;
      }
      > div:nth-child(2) {
        font-family: Montserrat, Montserrat;
        font-weight: 300;
        font-size: 20px;
        color: #666666;
        margin-top: 4px;
      }
      > div:nth-child(3) {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        line-height: 30px;
        margin-top: 31px;
      }
    }
    > div:nth-child(3) {
      display: flex;
      width: 180px;
      justify-content: flex-end;
      align-items: flex-end;
      padding-bottom: 28px;
      a {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #979797;
      }
    }
  }

  // 介绍
  .introduction {
    width: 926px;
    margin: 0 auto;
    height: 500px;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    img {
      height: 32px;
      width: 32px;
    }

    > div:nth-child(2) {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 32px;
      color: #103f9b;
      margin-top: 139px;
    }
    > div:nth-child(3) {
      font-family: Montserrat, Montserrat;
      font-weight: 300;
      font-size: 24px;
      color: #999999;
      margin-top: 6px;
    }
    > div:nth-child(4) {
      width: 1415px;
      height: 1016px;
      background: url("~@/assets/images/home/introduction.png") no-repeat center;
      background-size: contain;
      position: absolute;
      z-index: 1;
      top: -100px;
      left: -20px;
    }
  }

  // 解决方案
  .solutions {
    display: flex;
    flex-direction: column;
    align-items: center;
    > div:nth-child(1) {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 36px;
      color: #001b51;
    }
    > div:nth-child(2) {
      font-family: Montserrat, Montserrat;
      font-weight: 300;
      font-size: 20px;
      color: #666666;
    }
    > div:nth-child(3) {
      height: 612px;
      width: 100%;
      margin-top: 32px;
      background: url("~@/assets/images/home/solution_car.png") no-repeat top;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      .solutions-en {
        width: 778px !important;
      }
      > div {
        width: 378px;
        height: 432px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 4px 4px 0px 0px rgba(255, 255, 255, 0.25);
        border-radius: 0px 0px 0px 0px;
        padding: 31px 38px;
        box-sizing: border-box;
        word-break: break-all;
        > img:nth-child(1) {
          width: 32px;
          height: 32px;
        }
        > div:nth-child(2) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 24px;
          color: #333333;
          margin-top: 34px;
        }
        > div:nth-child(3) {
          font-family: Montserrat, Montserrat;
          font-weight: 300;
          font-size: 20px;
          color: #979797;
          margin-top: 7px;
        }
        > div:nth-child(4) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 18px;
          color: #666666;
          margin-top: 33px;
        }
        > div:nth-child(5) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          margin-top: 70px;
          cursor: pointer;
          img {
            width: 23px;
            height: 23px;
            margin-left: 12px;
            position: relative;
            top: 5px;
          }
        }
      }
    }
    .solutions-list {
      display: flex;
      width: 1200px;
      margin: 110px auto;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;
      > div:nth-child(1) {
        border-right: 2px solid rgba(0, 0, 0, 0.1);
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
      }
      > div:nth-child(2) {
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
      }
      > div:nth-child(3) {
        padding-top: 46px;
        border-right: 2px solid rgba(0, 0, 0, 0.1);
      }
      > div:nth-child(4) {
        padding-top: 46px;
      }
      .solution-list-ball {
        position: absolute;
        height: 40px;
        width: 40px;
        margin: auto;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: #fff;
        z-index: 10;
      }

      .solution-item {
        width: 600px;
        height: 480px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        padding: 0 50px;
        img {
          width: 100%;
          height: 270px;
          margin-bottom: 20px;
          transition: all 0.5s;
          cursor: pointer;
          &:hover {
            transform: scale(1.2);
          }
        }

        .solution-text {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 24px;
          width: 426px;
        }

        > div:nth-child(2) {
          font-family: Montserrat, Montserrat;
          font-weight: 300;
          font-size: 18px;
          color: #999999;
          margin-bottom: 4px;
        }

        > div:nth-child(3) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 28px;
          color: #222222;
          margin-bottom: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
            cursor: pointer;
          }
        }
      }
    }
  }

  // 合作伙伴
  .partners {
    display: flex;
    width: 100%;
    height: 946px;
    flex-direction: column;
    align-items: center;
    background: url("~@/assets/images/home/partner_bg.png") no-repeat center;
    background-size: cover;
    > div:nth-child(1) {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 36px;
      color: #001b51;
      margin-top: 50px;
    }
    > div:nth-child(2) {
      font-family: Montserrat, Montserrat;
      font-weight: 300;
      font-size: 20px;
      color: #666666;
      margin-bottom: 60px;
    }
    > div:nth-child(3) {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      flex-wrap: wrap;
      justify-content: space-between;
      img {
        width: 180px;
        height: 100px;
        margin-bottom: 30px;
      }
    }
  }

  // 济德咨询
  .news {
    display: flex;
    width: 100%;
    height: 946px;
    flex-direction: column;
    align-items: center;
    > div:nth-child(1) {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 36px;
      color: #001b51;
      margin-top: 120px;
    }
    > div:nth-child(2) {
      font-family: Montserrat, Montserrat;
      font-weight: 300;
      font-size: 20px;
      color: #666666;
      margin-bottom: 60px;
    }
    > div:nth-child(3) {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      flex-wrap: wrap;
      justify-content: space-between;
      > div {
        width: 376px;
        height: 494px;
        padding: 20px;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, 0.1);
        border-radius: 0px 0px 0px 0px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        > div:nth-child(1) {
          width: 336px;
          height: 194px !important;
          margin-bottom: 15px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
            cursor: pointer;
            transition: all 0.5s;
            &:hover {
              transform: scale(1.2);
            }
          }
        }
        > div:nth-child(2) {
          font-family: Montserrat, Montserrat;
          font-weight: 300;
          font-size: 18px;
          color: #999999;
          margin-bottom: 12px;
        }
        > div:nth-child(3) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 22px;
          color: #222222;
          margin-bottom: 18px;
          height: 65px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        > div:nth-child(4) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 18px;
          color: #666666;
          line-height: 30px;
          height: 60px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          margin-bottom: 35px;
        }
        > div:nth-child(5) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 18px;
          color: #103f9b;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
